import { Card, CardBody } from "react-bootstrap";

const Description = ({ rawDescription , title }) => {
    if (!rawDescription) return null;
    const cleanDescription = () => {
        if (rawDescription.includes("CDATA")) {
            return rawDescription
                .replace(/<!\[CDATA\[/g, "")
                .replace(/]]>/g, "");
        }
        return rawDescription;
    };
    return (
        <Card as={CardBody} className="border mb-3 rounded-md">
            <h5 className="text-lg font-semibold p-1">
                {title || "Description"}
            </h5>
            <div
                className="description p-3"
                dangerouslySetInnerHTML={{ __html: cleanDescription() }}
            />
        </Card>
    );
};

export default Description;
